__turbopack_context__.v({
  "buttonContainer": "ImageColTextForm-module-scss-module__TU7R5q__buttonContainer",
  "formHeading": "ImageColTextForm-module-scss-module__TU7R5q__formHeading",
  "formTagline": "ImageColTextForm-module-scss-module__TU7R5q__formTagline",
  "headingDescriptionText": "ImageColTextForm-module-scss-module__TU7R5q__headingDescriptionText",
  "headingTagline": "ImageColTextForm-module-scss-module__TU7R5q__headingTagline",
  "imageColTextForm": "ImageColTextForm-module-scss-module__TU7R5q__imageColTextForm",
  "imageColTextForm--imageSmallDesign": "ImageColTextForm-module-scss-module__TU7R5q__imageColTextForm--imageSmallDesign",
  "imageSection": "ImageColTextForm-module-scss-module__TU7R5q__imageSection",
  "textSection": "ImageColTextForm-module-scss-module__TU7R5q__textSection",
});
